import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { AuthenService } from '../../services/authen.service';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { debug } from 'util';
//import { setTimeout } from 'timers';
@Component({
    templateUrl: './hospital-profile-detail.html',
    styleUrls: ['./hospital-profile-detail.css'],
})
export class HospitalProfileDetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;
    itemChange: any = null;
    isSCFFM: boolean = false;


    @ViewChild("dialogEditHospitalField") dialogEditHospitalField: DialogComponent;
    dialogHeader: string = "Sửa thông tin hospital profile";
    dialogWidth: string = "60%";
    dialogHeight: string = "650px;";
    diaLogPosition: object = { X: 'center', Y: 'center' };




    fieldNameSelected: string = "";
    currentValue: string = "";
    changeValue: string = "";
    effectFrom: Date = null;
    effectTo: Date = null;
    dateFormat: string = 'dd/MM/yyyy';




    pageSettings: PageSettingsModel;
    gridData: DataManager;
    fieldNameSearch: string = "";
    statusSearch: string = "";
    arrStatus: Array<any> = [
        { "Value": "", "Name": "All" },
        { "Value": "waiting", "Name": "Waiting" },
        { "Value": "approved", "Name": "Approved" },
        { "Value": "rejected", "Name": "Rejected" }
    ];

    arrFieldName: Array<any> = [
        { "Value": "", "Name": "" },
        { "Value": "Address", "Name": "Địa chỉ" },
        { "Value": "AccountNumber", "Name": "TK ngân hàng (mặc định)" },
        { "Value": "AccountNumber2", "Name": "TK ngân hàng 2" },
        { "Value": "AccountNumber3", "Name": "TK ngân hàng 3" },
        { "Value": "AccountNumber4", "Name": "TK ngân hàng 4" },
        { "Value": "AccountNumber5", "Name": "TK ngân hàng 5" },
        { "Value": "AccountCode", "Name": "AccountCode" },
        { "Value": "Representative", "Name": "Người đại diện" },
        { "Value": "Position", "Name": "Vị trí/ chức vụ" },
        { "Value": "AuthorisedLetter", "Name": "Quyết định/Số ủy quyền" },
        { "Value": "BankCode", "Name": "Mã ngân hàng" },
        { "Value": "Telephone", "Name": "Điện thoại" },
        { "Value": "TaxCode", "Name": "Mã số thuế" },
        { "Value": "Email", "Name": "Email" },
        { "Value": "Note", "Name": "Ghi chú" },
    ];

    NameValueFields: Object = { text: 'Name', value: 'Value' };


    constructor(private http: HttpService, private auth: AuthenService
        , private route: ActivatedRoute
        , private helper: HelperService) {

        this.pageSettings = { pageSize: 15 };
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        });
        this.isSCFFM = this.auth.isSCFFM;
    }

    ngOnDestroy() {
        this.dialogEditHospitalField.hide();
        this.subs.unsubscribe();
    }

    ngOnInit() {
        
       
        if (this.id > 0) {
            this.GetHospitalProfileById(this.id);

        }
        setTimeout(() => {
            this.dialogEditHospitalField.hide();
        }, 200); 
    }

    GetHospitalProfileById(id: number) {
        this.http.get(`api/HospitalProfile/GetHospitalProfileById/${id}`, res => {

            this.item = res.Result;
            this.listFieldChangeByCustCode();
        });
    }

    isInputValid() {
        let msg = null;
        if (this.effectFrom == null) {
            msg = 'Please input effect from date';
        }
        else if (this.changeValue == null || this.changeValue == "") {
            msg = 'Please input value change';
        }

        return msg;
    }

    onSave() {
        let errMess = this.isInputValid();
        if (errMess != null) {
            this.helper.alertFailed(errMess);
        } else {

            let dataSave = {
                "CustomerCode": this.item.CustomerCode,
                "FieldName": this.fieldNameSelected,
                "Content": this.changeValue,
                "EffectFrom": this.effectFrom,
                "EffectTo": this.effectTo
            };
            this.http.saveSilent('api/HospitalProfile/BCSaveChange', dataSave, res => {
               
                if (res.LongID > 0) {
                    this.helper.alert("Save Successfully !");
                    this.dialogEditHospitalField.hide();
                } else {
                    this.helper.alertFailed("Save failed !");
                }
                this.resetForm();
                this.listFieldChangeByCustCode();


            }); 


           
        }

    }

    resetForm() {
        this.changeValue = null;
        this.effectFrom = null;
        this.effectTo = null;
    }

    openDialogEditField(fieldName: string) {
        this.dialogHeader = fieldName;
        if (fieldName == "Address") {
            this.currentValue = this.item.Address;
        } else if (fieldName == "Fax") {
            this.currentValue = this.item.Fax;
        } else if (fieldName == "AccountNumber") {
            this.currentValue = this.item.AccountNumber;
        } else if (fieldName == "AccountCode") {
            this.currentValue = this.item.AccountCode;
        } else if (fieldName == "Position") {
            this.currentValue = this.item.Position;
        } else if (fieldName == "AuthorisedLetter") {
            this.currentValue = this.item.AuthorisedLetter;
        } else if (fieldName == "BankCode") {
            this.currentValue = this.item.BankCode;
        } else if (fieldName == "Telephone") {
            this.currentValue = this.item.Telephone;
        } else if (fieldName == "TaxCode") {
            this.currentValue = this.item.TaxCode;
        } else if (fieldName == "AccountName") {
            this.currentValue = this.item.AccountName;
        } else if (fieldName == "Representative") {
            this.currentValue = this.item.Representative;
        } else if (fieldName == "Email") {
            this.currentValue = this.item.Email;
        } else if (fieldName == "Note") {
            this.currentValue = this.item.Note;
        } else if (fieldName == "AccountNumber2") {
            this.currentValue = this.item.AccountNumber2;
        } else if (fieldName == "AccountNumber3") {
            this.currentValue = this.item.AccountNumber3;
        } else if (fieldName == "AccountNumber4") {
            this.currentValue = this.item.AccountNumber4;
        } else if (fieldName == "AccountNumber5") {
            this.currentValue = this.item.AccountNumber5;
        } else if (fieldName == "HospitalName") {
            this.currentValue = this.item.HospitalName;
        }


        this.fieldNameSelected = fieldName;
        this.dialogEditHospitalField.show();
    }



    listFieldChangeByCustCode() {
        let paramSearch = {
            "CustomerCode": this.item.CustomerCode,
            "FieldName": this.fieldNameSearch,
            "Status": this.statusSearch
        };
        let dataFilter = JSON.stringify(paramSearch);
        this.gridData = this.http.getByManager(`api/HospitalProfile/SearchListFieldChangeByCustomer?filter=${dataFilter}`, this.auth);
    }


    renderStatusCol(status:string) {
        if (status == "waiting") {
            return "bg-warning";
        } else if (status == "approved") {
            return "bg-success";
        } else if (status == "rejected") {
            return "bg-danger";
        }
    }

    HSAction(changeId: number, status: string)
    {

        this.helper.confirm('Are you sure to change status this record ?', () => {
            this.http.get(`api/HospitalProfile/ChangeStatusHospitalField?id=${changeId}&status=${status}`, res => {
                if (res.LongID > 0) {
                    this.helper.alert("Change status successfully !");
                    if (status == "approved") {
                        this.GetHospitalProfileById(this.id);
                    }
                   
                    this.listFieldChangeByCustCode();
                } else {
                    this.helper.alertFailed("Action failed !, please contact for support");
                }
               
            });
        });

    }



    onDeleteWatingLineById(lineid: number) {
        this.helper.confirm('Are you sure you want to remove this waiting change?', () => {
            this.http.get(`api/HospitalProfile/DeleteHospitalFieldChangeWaiting?lineId=${lineid}`, res => {
                this.helper.alert("Delete successfully !");
                this.listFieldChangeByCustCode();
            });
        });
    }



}
